import { gql } from '@apollo/client'

export const CREATOR_QUERY = gql`
  query creatorCardQuery($_id: ID!) {
    creator(_id: $_id) {
      ... on Creator {
        _id
        groupId
        thumbnail
        isBrand
        country
        subscribers
        subscribersVariation
        isTrending
        isBrandGroup
        title
        topics {
          createdAt
          title
          topicId
        }
        isFollowing {
          benchmark
          competitor
          myBrand
        }
      }
      ... on CreatorPublic {
        _id
        thumbnail
        subscribers
        isTrending
        title
        groupId
        country
        topics {
          topicId
          title
        }
      }
    }
  }
`
